/** @format */
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonDirectiveModule } from '@dcsg-ngx-ecommerce/common/directives/directive.module';
import { WysiwygComponent } from './wysiwyg.component';

@NgModule({
	imports: [CommonDirectiveModule, CommonModule],
	declarations: [WysiwygComponent],
	bootstrap: [WysiwygComponent],
	exports: [WysiwygComponent],
	providers: [],
	schemas: [NO_ERRORS_SCHEMA]
})
export class WysiwygModule {}
